import { LocalStorageKeys } from '../constants/enums';

export const localStorageUtil = {
  set: (key: LocalStorageKeys, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get: (key: LocalStorageKeys) => {
    const value = localStorage.getItem(key);
    return JSON.parse(value || 'null');
  },
  remove: (key: LocalStorageKeys) => {
    return localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },
};
